import React, { useState, useEffect } from "react";
// import "./ezugi.css";
import Helper from "../../helper";
import axios from "axios";
import Appconfig from "../../config/config";
import Header from "../header/Header";
import Footer from "../Footer/Footer";
import ExposureHeader from '../ExposureHeader/ExposureHeader';
import EzugiAll from "./ezugiAll/index";
import EzugiMac88 from "./ezugiMac88/index";
import EzugiFunGames from "./ezugiFunGames";
import EzugiTurboGames from "./ezugiTurboGames";
import EzugiMac88Virtuals from "./ezugiMac88Virtuals";
import EzugiCasino from "./ezugiCasino";
import EzugiSpribeCasino from "./ezugiSpribeCasino";
import EzugiJili from "./ezugiJili";
import EzugiSmartSoft from "./ezugiSmartSoft";
import EzugiKingMaker from "./ezugiKingmaker";
import EzugiBetGamesTv from "./ezugiBetGamesTv";
import EzugiCrashGames from "./ezugiCrashGames";
import EzugiEvolution from "./ezugiEvolution";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";


const EzugiLobby = () => {
  const userInfo = Helper(); // get login user details
  const [activeCasino, setActiveCasino] = useState('All');
  const { state } = useLocation();

  function CreateAndLaunchWCOCasino(provider_code, game_code, type = null) {
    const userData = {
      user_id: userInfo?._id,
      user_name: userInfo?.user_name,
      redirect_url: 'https://daddyexch.live/',
      provider_code: provider_code,
      game_code: game_code,
      type: type,
    };

    var config = {
      method: "post",
      url: `${Appconfig.apiUrl}wco/login`,
      headers: {
        "Content-Type": "application/json",
      },

      data: JSON.stringify(userData),
    };

    axios(config)
      .then(function (response) {
        let status = response.data.status?.code;
        if (status === "SUCCESS") {
          window.open(response.data.launchURL, "_self");
        }

        if (status == "VALIDATION_ERROR" || status == "UNKNOWN_ERROR") {
          toast.error('Game Not Found.', { autoClose: 2000 });
        } else if (status == "AUTHENTICATION_FAILED") {
          toast.error(response.data.status?.message, { autoClose: 2000 });
        }

      })
      .catch(function (error) {
        console.log(error);
      });
  }

  const activeEzugiCasino = (casino) => {
    setActiveCasino(casino);
  }
  useEffect(() => {
    if (state?.activeCasino) {
      setActiveCasino(state?.activeCasino);
    }
    else {
      setActiveCasino('All');
    }
  }, [state?.activeCasino]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  return (
    <>
      {/* <Header /> */}
      {/* <ExposureHeader /> */}
      <div className="sub-new-nav">
        <div className="inner-sub-nav">
          <ul className="sub-nav-ul" id="slot-nav">
            <li className="slot-games-li" onClick={() => activeEzugiCasino('All')}>
              <button className={`li-button ${activeCasino === 'All' ? 'active-button' : ''} `} data-target="all-casino">
                <span>All</span>
              </button>
            </li>
            <li className="slot-games-li" onClick={() => activeEzugiCasino('MAC88')}>
              <button className={`li-button ${activeCasino === 'MAC88' ? 'active-button' : ''} `} data-target="mac88-casino">
                <span>MAC88</span>
              </button>
            </li>
            <li className="slot-games-li" onClick={() => activeEzugiCasino('Fun Games')}>
              <button className={`li-button ${activeCasino === 'Fun Games' ? 'active-button' : ''} `} data-target="fun-games-casino">
                <span>Fun Games</span>
              </button>
            </li>
            <li className="slot-games-li" onClick={() => activeEzugiCasino('Crash Games')}>
              <button className={`li-button ${activeCasino === 'Crash Games' ? 'active-button' : ''} `} data-target="crash-games-casino">
                <span>Crash Games</span>
              </button>
            </li>
            <li className="slot-games-li" onClick={() => activeEzugiCasino('Turbo Games')}>
              <button className={`li-button ${activeCasino === 'Turbo Games' ? 'active-button' : ''} `} data-target="turbo-games-casino">
                <span>Turbo Games</span>
              </button>
            </li>
            <li className="slot-games-li" onClick={() => activeEzugiCasino('Mac88 Virtuals')}>
              <button className={`li-button ${activeCasino === 'Mac88 Virtuals' ? 'active-button' : ''} `} data-target="mac88-virtuals-casino">
                <span>Mac88 Virtuals</span>
              </button>
            </li>
            <li className="slot-games-li" onClick={() => activeEzugiCasino('Ezugi')}>
              <button className={`li-button ${activeCasino === 'Ezugi' ? 'active-button' : ''} `} data-target="ezugi-casino">
                <span>Ezugi</span>
              </button>
            </li>
            <li className="slot-games-li" id="spribe" onClick={() => activeEzugiCasino('Spribe')}>
              <button className={`li-button ${activeCasino === 'Spribe' ? 'active-button' : ''} `} data-target="spribe-casino">
                <span>Spribe</span>
              </button>
            </li>
            <li className="slot-games-li" onClick={() => activeEzugiCasino('JiLi')}>
              <button className={`li-button ${activeCasino === 'JiLi' ? 'active-button' : ''} `} data-target="jili-casino">
                <span>JiLi</span>
              </button>
            </li>
            <li className="slot-games-li" onClick={() => activeEzugiCasino('Smart Soft')}>
              <button className={`li-button ${activeCasino === 'Smart Soft' ? 'active-button' : ''} `} data-target="smart-soft-casino">
                <span>Smart Soft</span>
              </button>
            </li>
            <li className="slot-games-li" onClick={() => activeEzugiCasino('KINGMAKER')}>
              <button className={`li-button ${activeCasino === 'KINGMAKER' ? 'active-button' : ''} `} data-target="kingmaker-casino">
                <span>KINGMAKER</span>
              </button>
            </li>
            <li className="slot-games-li" onClick={() => activeEzugiCasino('BetGames.TV')}>
              <button className={`li-button ${activeCasino === 'BetGames.TV' ? 'active-button' : ''} `} data-target="betgames-tv-casino">
                <span>BetGames.TV</span>
              </button>
            </li>
            <li className="slot-games-li" onClick={() => activeEzugiCasino('Evolution Gaming')}>
              <button className={`li-button ${activeCasino === 'Evolution Gaming' ? 'active-button' : ''} `} data-target="evolution-gaming-casino">
                <span>Evolution Gaming</span>
              </button>
            </li>

          </ul>
        </div>
      </div>

      <div className="image-section">
        <EzugiAll activeCasino={activeCasino} CreateAndLaunchWCOCasino={CreateAndLaunchWCOCasino} />
        <EzugiMac88 activeCasino={activeCasino} CreateAndLaunchWCOCasino={CreateAndLaunchWCOCasino} />
        <EzugiFunGames activeCasino={activeCasino} CreateAndLaunchWCOCasino={CreateAndLaunchWCOCasino} />
        <EzugiCrashGames activeCasino={activeCasino} CreateAndLaunchWCOCasino={CreateAndLaunchWCOCasino} />
        <EzugiTurboGames activeCasino={activeCasino} CreateAndLaunchWCOCasino={CreateAndLaunchWCOCasino} />
        <EzugiMac88Virtuals activeCasino={activeCasino} CreateAndLaunchWCOCasino={CreateAndLaunchWCOCasino} />
        <EzugiCasino activeCasino={activeCasino} CreateAndLaunchWCOCasino={CreateAndLaunchWCOCasino} />
        <EzugiSpribeCasino activeCasino={activeCasino} CreateAndLaunchWCOCasino={CreateAndLaunchWCOCasino} />
        <EzugiJili activeCasino={activeCasino} CreateAndLaunchWCOCasino={CreateAndLaunchWCOCasino} />
        <EzugiSmartSoft activeCasino={activeCasino} CreateAndLaunchWCOCasino={CreateAndLaunchWCOCasino} />
        <EzugiKingMaker activeCasino={activeCasino} CreateAndLaunchWCOCasino={CreateAndLaunchWCOCasino} />
        <EzugiBetGamesTv activeCasino={activeCasino} CreateAndLaunchWCOCasino={CreateAndLaunchWCOCasino} />
        <EzugiEvolution activeCasino={activeCasino} CreateAndLaunchWCOCasino={CreateAndLaunchWCOCasino} />
      </div>
      {/* <Footer /> */}
    </>
  );
};

export default EzugiLobby;
